import PropTypes from 'prop-types';

import marketShape from 'common/PropTypes/marketShape';

const eventParticipantShape = PropTypes.shape({
  fullName: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  logoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export default PropTypes.shape({
  categoryId: PropTypes.number.isRequired,
  categoryName: PropTypes.string.isRequired,
  externalId: PropTypes.string,
  id: PropTypes.number.isRequired,
  info: PropTypes.shape({
    score: PropTypes.shape({
      awayScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      homeScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      liveStatus: PropTypes.string.isRequired,
      matchClock: PropTypes.string,
    }),
    stats: PropTypes.shape({
      periodInfo: PropTypes.objectOf(
        PropTypes.shape({
          awayScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          homeScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          matchStatusCode: PropTypes.number.isRequired,
          periodDescription: PropTypes.string.isRequired,
          periodNumber: PropTypes.number.isRequired,
          shortPeriodDescription: PropTypes.string,
        }),
      ),
    }),
  }),
  isTop: PropTypes.bool.isRequired,
  markets: PropTypes.objectOf(marketShape),
  name: PropTypes.string.isRequired,
  participants: PropTypes.shape({
    away: eventParticipantShape,
    home: eventParticipantShape,
  }),
  sportId: PropTypes.number.isRequired,
  sportName: PropTypes.string.isRequired,
  sportService: PropTypes.oneOf(['LIVE', 'PREMATCH', 'ARCHIVED', 'UNSPECIFIED']),
  startTime: PropTypes.number.isRequired,
  stats: PropTypes.shape({
    away: PropTypes.shape({ points: PropTypes.number }),
    home: PropTypes.shape({ points: PropTypes.number }),
  }),
  status: PropTypes.oneOf(['ACTIVE', 'SUSPENDED', 'HIDDEN']),
  tournamentId: PropTypes.number.isRequired,
  tournamentName: PropTypes.string.isRequired,
});
